












import { Component, Vue } from "vue-property-decorator";
import PasswordResetCard from "@/components/Account/PasswordResetCard.vue";
import RequestResetLinkCard from "@/components/Account/RequestResetLinkCard.vue";

@Component({
  components: {
    PasswordResetCard,
    RequestResetLinkCard
  }
})
export default class ResetPassword extends Vue {
  private token: string = "";

  mounted() {
    this.token = (this.$route.query.token || "") as string;
  }
}
